import React from 'react';
import { BuyerInfoUser } from '@/types';
import theme from './ResidentialExpandedListItem.module.scss';
import BuyerCard from './BuyerCard';
import { inviteResidentialUnitBuyer, resendResidentialUnitBuyerInvitation } from '@/services/residential-units';

interface ExtraBuyerInfoProps {
    buyers: BuyerInfoUser[];
}

const ExtraBuyerInfo: React.FC<ExtraBuyerInfoProps> = ({ buyers }) => {
    const handleSendInvite = async (buyer: BuyerInfoUser, sendEmail: boolean, sendSms: boolean) => {
        const response = await resendResidentialUnitBuyerInvitation(buyer.inviteId, { sendEmail, sendSms })
        console.log('response', response);
    };


    return (
        <div className={theme.buyersContainer}>
            {buyers.map((buyer) => (
                <BuyerCard
                    key={`${buyer.userId}_${buyer.inviteId}`}
                    buyer={buyer}
                    onSendInvite={handleSendInvite}
                />
            ))}
        </div>
    );
};

export default ExtraBuyerInfo; 